import * as Actions from './SessionRegistrantsActions';

const initialState = {
  fetching: false,
  registrants: [],
  page: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    number: 0
  },
  error: null,
  filter: {
    textSearch: ''
  },
  sort: {
    sortBy: null,
    sortOrder: null
  }
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_REGISTRANTS_REQUEST: {
      return { ...state, fetching: true };
    }
    case Actions.GET_SESSION_REGISTRANTS_SUCCESS: {
      const { registrants, filter, page, sort } = action.payload;
      return {
        ...state,
        registrants,
        page,
        filter,
        sort,
        fetching: false
      };
    }
    case Actions.GET_SESSION_REGISTRANTS_FAILURE: {
      return { ...state, ...initialState, error: action.error, fetching: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionRegistrants/SessionRegistrantsReducer.js